'use client';

import { c as _c } from "react/compiler-runtime";
import { FeatherAlertTriangle, FeatherSearch } from '@subframe/core';
import { useEffect, useState } from 'react';
import { Button, Loader, TextArea, TextField } from '@/shared/components/ui';
import { BUSCA_CONTEXTO_MENSAGENS } from '../constants';
import type { UseNegociacaoSelfReturn } from '../hooks';
import { ResumoLinhaEmLinha } from './ResumoLinha';
import { WizardFooter } from './WizardFooter';
import { WizardProgressHeader } from './WizardProgressHeader';
const CNPJ_AVISO_ID = 'perfil-self-cnpj-aviso';
interface PerfilScreenProps {
  vm: UseNegociacaoSelfReturn;
}
export const PerfilScreen = t0 => {
  const $ = _c(32);
  const {
    vm
  } = t0;
  const [mensagemIndex, setMensagemIndex] = useState(0);
  let t1;
  let t2;
  if ($[0] !== vm.buscandoContexto) {
    t1 = () => {
      if (!vm.buscandoContexto) {
        setMensagemIndex(0);
        return;
      }
      const intervalo = setInterval(() => {
        setMensagemIndex(_temp);
      }, 1400);
      return () => clearInterval(intervalo);
    };
    t2 = [vm.buscandoContexto];
    $[0] = vm.buscandoContexto;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  const camposBloqueados = vm.buscandoContexto;
  const avisoCnpjTexto = vm.cnpjError ? "N\xE3o conseguimos consultar o CNPJ agora. Preencha o nome da empresa abaixo ou tente de novo." : "N\xE3o encontramos os dados desse CNPJ. Preencha o nome da empresa abaixo.";
  const temAvisoCnpj = vm.cnpjEncontrado === false || Boolean(vm.cnpjError);
  let t3;
  if ($[3] !== vm.wizardSteps) {
    t3 = <WizardProgressHeader steps={vm.wizardSteps} />;
    $[3] = vm.wizardSteps;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="flex flex-col gap-2"><h1 className="text-heading-dark text-2xl font-semibold sm:text-[30px]">Quem é você e qual é o seu negócio?</h1><p className="text-label-muted max-w-[420px] text-base leading-relaxed">Essas informações ajudam a Lexi a entender seu contexto e negociar com mais precisão por você.</p></div>;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== vm.buscouContexto || $[7] !== vm.editarDados || $[8] !== vm.perfil) {
    t5 = vm.buscouContexto && <div className="flex items-start justify-between gap-4 rounded-[10px] border border-solid border-neutral-200 bg-neutral-50 px-4 py-4"><div className="flex flex-col gap-1.5"><ResumoLinhaEmLinha rotulo="Nome completo" valor={vm.perfil.nome} /><ResumoLinhaEmLinha rotulo="E-mail" valor={vm.perfil.email} /><ResumoLinhaEmLinha rotulo="CNPJ" valor={vm.perfil.cnpj} /><ResumoLinhaEmLinha rotulo={"Raz\xE3o social"} valor={vm.perfil.razaoSocial} /><ResumoLinhaEmLinha rotulo="Nome fantasia" valor={vm.perfil.nomeFantasia} /><ResumoLinhaEmLinha rotulo="Site" valor={vm.perfil.site} /></div><button type="button" onClick={vm.editarDados} className="text-brand-600 flex-none text-[13px] font-semibold underline">Editar</button></div>;
    $[6] = vm.buscouContexto;
    $[7] = vm.editarDados;
    $[8] = vm.perfil;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== avisoCnpjTexto || $[11] !== camposBloqueados || $[12] !== mensagemIndex || $[13] !== temAvisoCnpj || $[14] !== vm) {
    t6 = !vm.buscouContexto && <><TextField className="w-full" disabled={camposBloqueados} label="Nome completo *" error={vm.showNomeError} helpText={vm.showNomeError ? "Preenche este campo para continuar" : undefined}><TextField.Input disabled={camposBloqueados} placeholder={"Ex: Jo\xE3o da Silva"} value={vm.perfil.nome} onChange={event => vm.atualizarPerfil("nome", event.target.value)} /></TextField><TextField className="w-full" disabled={camposBloqueados} label="E-mail *" error={vm.showEmailError} helpText={vm.showEmailError ? "Digite um e-mail v\xE1lido para continuar" : undefined}><TextField.Input disabled={camposBloqueados} placeholder="Ex: joao@empresa.com.br" value={vm.perfil.email} onChange={event_0 => vm.atualizarPerfil("email", event_0.target.value)} /></TextField><TextField className="w-full" disabled={camposBloqueados} label="CNPJ *" error={vm.showCnpjError} helpText={vm.showCnpjError ? "Digite um CNPJ v\xE1lido para continuar" : "Buscamos o nome da empresa automaticamente pelo CNPJ"}><TextField.Input disabled={camposBloqueados} placeholder="Ex: 00.000.000/0000-00" value={vm.perfil.cnpj} aria-describedby={temAvisoCnpj ? CNPJ_AVISO_ID : undefined} onChange={event_1 => vm.atualizarPerfil("cnpj", event_1.target.value)} onBlur={vm.consultarCnpjEmpresa} /></TextField><div aria-live="polite" className="empty:hidden">{vm.consultandoCnpj && <div className="text-label-muted -mt-2 flex items-center gap-2 text-[13px]"><Loader size="small" /><span>Buscando os dados da empresa pelo CNPJ...</span></div>}{temAvisoCnpj && <div id={CNPJ_AVISO_ID} className="border-warning-200 bg-warning-50 -mt-2 flex items-start gap-2.5 rounded-[8px] border border-solid px-3.5 py-3"><FeatherAlertTriangle className="text-warning-700 mt-0.5 flex-none" /><div className="text-warning-700 flex flex-col items-start gap-1 text-[13px] leading-relaxed"><span>{avisoCnpjTexto}</span>{vm.cnpjError && <button type="button" onClick={vm.reconsultarCnpjEmpresa} className="font-semibold underline">Tentar consultar novamente</button>}</div></div>}</div><TextField className="w-full" disabled={camposBloqueados} label={"Raz\xE3o social da empresa *"} error={vm.showRazaoSocialError} helpText={vm.showRazaoSocialError ? "Preenche este campo para continuar" : undefined}><TextField.Input disabled={camposBloqueados} placeholder="Ex: Arbitralis Tecnologia Ltda" value={vm.perfil.razaoSocial} onChange={event_2 => vm.atualizarPerfil("razaoSocial", event_2.target.value)} /></TextField><TextField className="w-full" disabled={camposBloqueados} label="Nome fantasia da empresa *" error={vm.showNomeFantasiaError} helpText={vm.showNomeFantasiaError ? "Preenche este campo para continuar" : undefined}><TextField.Input disabled={camposBloqueados} placeholder="Ex: Arbitralis" value={vm.perfil.nomeFantasia} onChange={event_3 => vm.atualizarPerfil("nomeFantasia", event_3.target.value)} /></TextField><TextField className="w-full" disabled={camposBloqueados} label="Site da empresa *" error={vm.showSiteError} helpText={vm.showSiteError ? "Preenche este campo para continuar" : undefined}><TextField.Input disabled={camposBloqueados} placeholder="Ex: https://arbitralis.com.br" value={vm.perfil.site} onChange={event_4 => vm.atualizarPerfil("site", event_4.target.value)} /></TextField><Button size="small" className="self-start" icon={<FeatherSearch />} loading={vm.buscandoContexto} disabled={vm.buscandoContexto || vm.consultandoCnpj} onClick={vm.buscarContexto}>{vm.buscandoContexto ? "Buscando..." : "Buscar"}</Button>{vm.buscandoContexto && <span className="text-label-muted animate-pulse text-sm leading-snug">{BUSCA_CONTEXTO_MENSAGENS[mensagemIndex]}</span>}</>;
    $[10] = avisoCnpjTexto;
    $[11] = camposBloqueados;
    $[12] = mensagemIndex;
    $[13] = temAvisoCnpj;
    $[14] = vm;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== vm) {
    t7 = vm.buscouContexto && <div className="flex w-full flex-col gap-2"><TextArea className="w-full" label="Sobre sua empresa *" helpText="Conte o que sua empresa faz e como atua no mercado"><TextArea.Input value={vm.perfil.sobre} onChange={event_5 => vm.atualizarPerfil("sobre", event_5.target.value)} /></TextArea>{!vm.contextoEncontrado && <div className="border-warning-200 bg-warning-50 flex items-start gap-2.5 rounded-[8px] border border-solid px-3.5 py-3"><FeatherAlertTriangle className="text-warning-700 mt-0.5 flex-none" /><div className="text-warning-700 text-[13px] leading-relaxed"><div className="font-semibold">Não encontramos contexto para esta empresa automaticamente.</div><div>Descreva sua empresa no campo acima para continuar.</div></div></div>}</div>;
    $[16] = vm;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t5 || $[19] !== t6 || $[20] !== t7) {
    t8 = <div className="flex flex-1 justify-center px-6 py-10 md:px-20 md:py-16"><div className="grid w-full max-w-[1280px] grid-cols-1 gap-10 lg:grid-cols-[minmax(260px,1fr)_minmax(380px,1.6fr)] lg:gap-20">{t4}<div className="flex w-full flex-col gap-5">{t5}{t6}{t7}</div></div></div>;
    $[18] = t5;
    $[19] = t6;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== vm) {
    t9 = () => vm.goTo("objetivo");
    $[22] = vm;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  const t10 = !vm.podeAvancarPerfil;
  let t11;
  if ($[24] !== t10 || $[25] !== t9 || $[26] !== vm.avancarDoPerfil) {
    t11 = <WizardFooter onVoltar={t9} onAvancar={vm.avancarDoPerfil} avancarDisabled={t10} />;
    $[24] = t10;
    $[25] = t9;
    $[26] = vm.avancarDoPerfil;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  let t12;
  if ($[28] !== t11 || $[29] !== t3 || $[30] !== t8) {
    t12 = <div className="flex min-h-screen w-full flex-col bg-white">{t3}{t8}{t11}</div>;
    $[28] = t11;
    $[29] = t3;
    $[30] = t8;
    $[31] = t12;
  } else {
    t12 = $[31];
  }
  return t12;
};
function _temp(indice) {
  return (indice + 1) % BUSCA_CONTEXTO_MENSAGENS.length;
}